import MainRouterView from '@/components/layouts/main/partition/MainRouterView';

import InfoPage from '@/pages/Info';

import RatingPage from '@/pages/Rating/List/';
import LMSPRequestPage from '@/pages/LMSP/Request';

import RegistryListPage from '@/pages/Registry/List';
import RegistryDetailPage from '@/pages/Registry/Detail';

import DictionaryListPage from '@/pages/Dictionary/List';
import DictionaryRequestPage from '@/pages/Dictionary/Request';

import ConditionListPage from '@/pages/Condition/List';

import OperatorDictionaryListPage from '@/pages/Operator/Dictionary/List';
import OperatorDictionaryRequestPage from '@/pages/Operator/Dictionary/Request';

import HeadRegistryListPage from '@/pages/Head/Registry/List';
import HeadRegistryDetailPage from '@/pages/Head/Registry/Detail';

import OperatorRegistryListPage from '@/pages/Operator/Registry/List';
import OperatorRegistryDetailPage from '@/pages/Operator/Registry/Detail';

export default [
  {
    path: '/info',
    name: 'info',
    component: InfoPage,
  },
  {
    path: '/registry',
    name: 'registry',
    component: MainRouterView,
    redirect: {
      name: 'registry.list',
    },
    children: [
      {
        path: '',
        name: 'registry.list',
        component: RegistryListPage,
        meta: {
          contentClass: 'overflow-x-hidden',
        },
      },
      {
        path: ':id',
        name: 'registry.detail',
        component: RegistryDetailPage,
      },
    ],
  },
  {
    path: '/lmsp',
    name: 'lmsp.request',
    component: LMSPRequestPage,
  },
  {
    path: '/conditions',
    name: 'condition.list',
    component: ConditionListPage,
  },
  {
    path: '/dictionary',
    name: 'dictionary',
    component: MainRouterView,
    redirect: {
      name: 'dictionary.list',
    },
    children: [
      {
        path: 'list',
        name: 'dictionary.list',
        component: DictionaryListPage,
      },
      {
        path: 'request',
        name: 'dictionary.request',
        component: DictionaryRequestPage,
      },
    ],
  },
  {
    path: '/rating',
    component: MainRouterView,
    children: [
      {
        path: '',
        name: 'rating',
        component: RatingPage,
      },
    ],
  },
  {
    path: '/head',
    name: 'head',
    component: MainRouterView,
    redirect: {
      name: 'head.register',
    },
    children: [
      {
        path: 'dictionary',
        name: 'head.dictionary',
        component: MainRouterView,
        redirect: {
          name: 'head.condition.list',
        },
        children: [
          {
            path: '',
            name: 'head.condition.list',
            component: ConditionListPage,
          },
        ],
      },
      {
        path: 'register',
        name: 'head.register',
        component: MainRouterView,
        redirect: {
          name: 'head.register.list',
        },
        children: [
          {
            path: '',
            name: 'head.register.list',
            component: HeadRegistryListPage,
            meta: {
              contentClass: 'overflow-x-hidden',
            },
          },
          {
            path: ':id',
            name: 'head.register.detail',
            component: HeadRegistryDetailPage,
          },
        ],
      },
    ],
  },
  {
    path: '/operator',
    name: 'operator',
    component: MainRouterView,
    redirect: {
      name: 'operator.dictionary',
    },
    children: [
      {
        path: 'conditions',
        name: 'operator.condition.list',
        component: ConditionListPage,
      },
      {
        path: 'dictionary',
        name: 'operator.dictionary',
        component: MainRouterView,
        redirect: {
          name: 'operator.dictionary.list',
        },
        children: [
          {
            path: '',
            name: 'operator.dictionary.list',
            component: OperatorDictionaryListPage,
          },
          {
            path: ':id',
            name: 'operator.dictionary.detail',
            component: OperatorDictionaryRequestPage,
          },
        ],
      },
      {
        path: 'register',
        name: 'operator.register',
        component: MainRouterView,
        redirect: {
          name: 'operator.register.list',
        },
        children: [
          {
            path: '',
            name: 'operator.register.list',
            component: OperatorRegistryListPage,
            meta: {
              contentClass: 'overflow-x-hidden',
            },
          },
          {
            path: ':id',
            name: 'operator.register.detail',
            component: OperatorRegistryDetailPage,
          },
        ],
      },
    ],
  },
];
